var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","color":_vm.color}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }